import { type MouseEventHandler, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { scrollSpy } from 'react-scroll';

import { Grid } from '@mui/material';

import { styles } from './constants';
import Menu from './menu';

import { defaultScrollOffset, useScrollableLink } from '../hooks/use-scrollable-link';

import './header.scss';

const Header = () => {
  const stickyMenuMaxInnerWidth = 992;

  const isNotStickyWidth = () => window.innerWidth < stickyMenuMaxInnerWidth;
  const containerRef = useRef<HTMLDivElement>(null);

  const [isSticky, setIsSticky] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [scrollOffset, setScrollOffset] = useState(defaultScrollOffset);

  const navigate = useNavigate();
  const { get: getScrollableLink } = useScrollableLink();

  useEffect(() => {
    const handleResize = () => {
      if (isNotStickyWidth()) {
        setScrollOffset(0);
        return;
      }

      setScrollOffset(defaultScrollOffset);
    };
    const handleScroll = () => {
      if (!containerRef.current) {
        return;
      }

      if (isNotStickyWidth()) {
        setIsSticky(false);
        return;
      }

      if (window.pageYOffset > containerRef.current.clientHeight) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    // Updating scrollSpy when the component mounts.
    scrollSpy.update();

    handleResize();

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const onMenuClick = (link: string): void & MouseEventHandler<HTMLButtonElement> => {
    if (isNotStickyWidth()) {
      setOpenMenu(!openMenu);
    } else if (openMenu) {
      setOpenMenu(false);
    }

    navigate(`/#${link}`);
  };

  return (
    <>
      <Grid
        container
        ref={containerRef}
        spacing={2}
        id={'header'}
        className={isSticky ? 'header stickyHeader' : 'header'}
      >
        <Grid size={isSticky ? 4 : 2} className="logoContainer first-img">
          {getScrollableLink(
            <img
              src={isSticky ? 'images/ice_sports_varna_logo_w.png' : 'images/ice_sports_varna_logo.png'}
              alt="Ice Sports Varna"
            />,
            styles.ids.root,
            () => onMenuClick('')
          )}
        </Grid>
        {!isSticky && (
          <Grid size={2} className="logoContainer second-img">
            {getScrollableLink(
              <img src="images/logo_bsic.png" alt="Black Sea Ice Cup" />,
              styles.ids.bsic,
              onMenuClick,
              scrollOffset
            )}
          </Grid>
        )}

        <Menu
          customClass={openMenu ? 'menu open' : 'menu'}
          hasLang={true}
          scrollOffset={scrollOffset}
          size={8}
          onClick={(link: string) => onMenuClick(link)}
        />

        <div
          className="menuBtn"
          onClick={() => {
            setOpenMenu(!openMenu);
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </Grid>
    </>
  );
};

export default Header;
